module.exports = __webpack_public_path__ + "static/media/02.6b5d2d87.jpg";